import { cn } from "@/lib/utils";

/**
 * The filled track used for SBC progress: Streamline's item score, a set's
 * solved count. The label that names the ratio is printed by the caller, so
 * the bar itself stays a bar.
 */
export const ProgressBar = ({
  ratio,
  small = false,
  className,
}: {
  /** 0..1. */
  ratio: number;
  small?: boolean;
  className?: string;
}) => (
  <div
    className={cn(
      "w-full overflow-hidden rounded-full bg-sbc-border",
      small ? "h-1.5" : "h-2",
      className,
    )}
  >
    <div
      className="h-full rounded-full bg-[linear-gradient(90deg,var(--color-streamline-progress-from),var(--color-streamline-progress-to))] transition-[width] duration-[350ms] ease-out"
      style={{ width: `${Math.min(Math.max(ratio, 0), 1) * 100}%` }}
    />
  </div>
);
